import { Injectable } from '@angular/core';
import { Category, Report } from '../../../documents';
import { Settings } from '../../../core';

@Injectable()
export class FileExtensions {
    constructor(private readonly settings: Settings) { }

    public getAllowedFileExtensions(report: Report) {
        const categoryHasElearningSubcategories = report.category.categoryId === 'training-materials'
            || report.category.categoryId === 'sponsor-communications';

        return categoryHasElearningSubcategories
            ? this.settings.uploadedFileExtensionsByCategoryId(report.subcategoryId)
            : this.settings.uploadedFileExtensionsByCategoryId(report.category.categoryId);
    }
}